import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { AuthService } from './auth.service';
import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class HttpService
{
    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private log: LogService
    )
    {
    }

    setHeader(method, token, user_id, download_id)
    {
        let headers = new HttpHeaders({
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token,
        });

        if (method == 'post') {
            headers = headers.set('enctype', 'multipart/form-data; boundary=----WebKitFormBoundaryBw4G0PEdI6huPyKX');
        }

        if (!this.auth.empty(user_id)) {
            headers = headers.set('X-Hozon-User', String(user_id));
        }
        if (!this.auth.empty(download_id)) {
            headers = headers.set('X-Hozon-Download-Id', String(download_id));
        }

        return headers;
    }

    request(method, url, formData, token, user_id, download_id, type)
    {
        const headers = this.setHeader(method, token, user_id, download_id);

        this.log.debug(['request', method, url, formData, token, user_id, download_id]);

        if (method == 'post') {
            return this.http.post(url, formData, { headers: headers, observe: 'response',  responseType: type, withCredentials: true});
        } else {
            return this.http.get(url, { headers: headers, observe: 'response',  responseType: type, withCredentials: true});
        }
    }
}
